import { render, staticRenderFns } from "./PopulatePixel.vue?vue&type=template&id=74b48e74&scoped=true&"
import script from "./PopulatePixel.vue?vue&type=script&lang=js&"
export * from "./PopulatePixel.vue?vue&type=script&lang=js&"
import style0 from "./PopulatePixel.vue?vue&type=style&index=0&id=74b48e74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b48e74",
  null
  
)

export default component.exports